export const LABEL_KINDS = ["location"] as const;
export type LabelKind = (typeof LABEL_KINDS)[number];

export const DEFAULT_BAND_COLOR = "#F5D76E";
export const MAX_LABELS = 500;
export const TOO_MANY_LABELS = `That is more than ${MAX_LABELS} labels.`;
export const LOCATION_TAPE_WIDTH_IN = 1;
export const LOCATION_LABEL_LENGTH_IN = 3.5;

// The same artwork a single location label uses on the create and edit pages.
export function locationLabelPayload(codes: string[]) {
  return {
    kind: "location",
    codes,
    tape_width_in: LOCATION_TAPE_WIDTH_IN,
    label_length_in: LOCATION_LABEL_LENGTH_IN,
    autosize: true,
    show_qr: true,
    settings: { default_color: DEFAULT_BAND_COLOR },
  };
}

// Copies repeat every code, so the printed length is the batch size times the copy count.
export function repeatedLabelCount(codeCount: number, copies: number): number {
  const count = Math.max(1, Math.trunc(copies) || 1);
  return Math.max(0, codeCount) * count;
}
